import './App.css';
import { Route, Routes } from "react-router-dom"
import Landing from './pages/Landing';
import Login from './pages/Login';
import Manager from './pages/Manager'
import CardScreen from './pages/CardScreen';
import {useEffect} from "react";

// YOU NEED TO KEEP THIS
import 'react-toastify/dist/ReactToastify.css';


function App() {
    useEffect(
        () => {
            console.log("Hey, I'm Eren. I made this website.");
            console.log("Here's a small reward cuz you were curious: email: xx@xx.com, pass: xxx123")
        }, []
    )
    return (
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/manager" element={<Manager />} />
          <Route path="/card-screen" element={<CardScreen />} />
        </Routes>
    );
}

export default App;